// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Oyk0","selected":"Chip_selected__dr354"};